// @ts-nocheck
import { createPortal } from 'react-dom';
import { AppBar, Box, Button, ButtonBase, Modal, Toolbar, Typography, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import Banner from "./Banner";
import Footer from "./Footer";
import Logo from "./Logo";
import MainNavigation from "./MainNavigation";
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { TransformWrapper, TransformComponent, useTransformComponent } from "react-zoom-pan-pinch";
import Video from "./Video";
import { useRef, useState } from "react";
import { Document, Page } from 'react-pdf'
import { pdfjs } from 'react-pdf';
import HTMLFlipBook from "react-pageflip";
import React from "react";
import { Padding } from "@mui/icons-material";
import { Krpano } from "@0xllllh/react-krpano";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

const Pages = React.forwardRef((props, ref) => {
    return (
        <Page width={550} height={733} pageNumber={props.number}>
        </Page>
    );
});

Pages.displayName = 'Pages';

const h = 831;
const w = 600;
const prefix = "book/Pinoccothek_pages-to-jpg-00";

export default function Test() {
    const [isLoaded, setLoaded] = useState(false);

    function onDocumentLoadSuccess({ numPages }) {
        setLoaded(true);
    }
    function pad(i) {
        if (i<10) return "0" + i;
        return "" + i;
    }
    const listItems = [...Array(39).keys()].map((n) => (<img src={prefix + pad(n+1) + ".jpg"}></img>));

    return (
        <div>
            <Document file="book/pinocchiade_english.pdf" onLoadSuccess={onDocumentLoadSuccess}>
                {isLoaded &&
                    <HTMLFlipBook width={550}
                        height={733}
                        size="stretch"
                        minWidth={315}
                        maxWidth={1000}
                        minHeight={400}
                        maxHeight={1533}
                        maxShadowOpacity={0.5}
                        showCover={true}
                        mobileScrollSupport={true}>
                        {listItems}
                    </HTMLFlipBook>
                }
            </Document>
        </div>
    )
}